import React from 'react';
import RegisterComponent from '@/views/auth/register/Register.component';

export default function RegisterView() {
  return (
    <div className='flex flex-col mx-auto w-96 text-sm pb-8'>
      <RegisterComponent />
    </div>
  );
}
